import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AccordionItem } from '../accordion.component';

@Component({
  selector: 'kion-accordion-list-item',
  templateUrl: './accordion-list-item.component.html',
  styleUrls: ['./accordion-list-item.component.scss']
})
export class AccordionListItemComponent {

  @Input() item: AccordionItem;
  @Input() open: boolean;

  // tslint:disable-next-line:no-output-native
  @Output('toggle') toggleAccordionEmitter: EventEmitter<{item: AccordionItem, open: boolean}> = new EventEmitter<{item: AccordionItem, open: boolean}>();

  toggleAccordion(): void {
    this.open = !this.open;
    this.toggleAccordionEmitter.emit({item: this.item, open: this.open});
  }
}
